document.addEventListener('DOMContentLoaded', function () {
    const track = document.getElementById('csTrack');
    const prevBtn = document.querySelector('.cs-prev');
    const nextBtn = document.querySelector('.cs-next');
    const viewport = document.getElementById('csViewport');

    if (!track || track.children.length === 0) return;

    let cards = Array.from(track.children);
    let cardWidth = cards[0].getBoundingClientRect().width;
    let gap = 20; // 必须与 CSS 中的 gap 一致
    let scrollAmount = cardWidth + gap;
    let currentIndex = 0;
    let autoScrollInterval;
    let isTransitioning = false;

    // 1. 初始化：克隆节点以实现无限滚动
    // 我们需要克隆足够多的节点来填充屏幕两侧，防止看到空白
    const cloneCount = Math.ceil(viewport.clientWidth / scrollAmount) + 2;

    // 向前克隆 (放在前面)
    for (let i = 0; i < cloneCount; i++) {
        let clone = cards[cards.length - 1 - (i % cards.length)].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, track.firstChild);
    }

    // 向后克隆 (放在后面)
    for (let i = 0; i < cloneCount; i++) {
        let clone = cards[i % cards.length].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
    }

    // 重新获取所有卡片 (包含克隆的)
    let allCards = Array.from(track.children);

    // 初始位置：跳过前面克隆的部分，定位到第一个真实元素
    // 真实元素现在位于索引 cloneCount 处
    let realStartIndex = cloneCount;
    currentIndex = realStartIndex;

    // 设置初始 Transform (无动画)
    track.style.transition = 'none';
    track.style.transform = `translateX(-${currentIndex * scrollAmount}px)`;

    // 2. 滚动函数
    const scrollToIndex = (index, withAnimation = true) => {
        if (isTransitioning && withAnimation) return;

        if (withAnimation) {
            isTransitioning = true;
            track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
        } else {
            track.style.transition = 'none';
        }

        track.style.transform = `translateX(-${index * scrollAmount}px)`;

        if (withAnimation) {
            setTimeout(() => {
                isTransitioning = false;
                handleInfiniteLoop(index);
            }, 500); // 匹配 CSS transition 时间
        }
    };

    // 3. 处理无限循环逻辑 (瞬移)
    const handleInfiniteLoop = (currentIdx) => {
        const totalRealCards = cards.length;
        const thresholdLow = cloneCount;
        const thresholdHigh = cloneCount + totalRealCards - 1;

        // 如果滚到了前面的克隆区
        if (currentIdx < thresholdLow) {
            const newIndex = currentIdx + totalRealCards;
            track.style.transition = 'none';
            track.style.transform = `translateX(-${newIndex * scrollAmount}px)`;
            currentIndex = newIndex;
        }
        // 如果滚到了后面的克隆区
        else if (currentIdx > thresholdHigh) {
            const newIndex = currentIdx - totalRealCards;
            track.style.transition = 'none';
            track.style.transform = `translateX(-${newIndex * scrollAmount}px)`;
            currentIndex = newIndex;
        }
    };

    // 4. 按钮事件
    const nextSlide = () => {
        currentIndex++;
        scrollToIndex(currentIndex);
        resetAutoScroll();
    };

    const prevSlide = () => {
        currentIndex--;
        scrollToIndex(currentIndex);
        resetAutoScroll();
    };

    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);

    // 5. 自动滚动
    const startAutoScroll = () => {
        stopAutoScroll();
        autoScrollInterval = setInterval(() => {
            if (!isTransitioning) {
                nextSlide();
            }
        }, 300000000); // 3 秒滚动一次
    };

    const stopAutoScroll = () => {
        if (autoScrollInterval) clearInterval(autoScrollInterval);
    };

    const resetAutoScroll = () => {
        stopAutoScroll();
        startAutoScroll();
    };

    // 交互暂停
    viewport.addEventListener('mouseenter', stopAutoScroll);
    viewport.addEventListener('mouseleave', startAutoScroll);

    // 触摸设备支持 (简单的滑动检测)
    let touchStartX = 0;
    let touchEndX = 0;

    viewport.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoScroll();
    }, { passive: true });

    viewport.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleGesture();
        startAutoScroll();
    }, { passive: true });

    function handleGesture() {
        if (touchEndX < touchStartX - 50) nextSlide(); // 左滑
        if (touchEndX > touchStartX + 50) prevSlide(); // 右滑
    }

    // 6. 窗口大小改变时重置 (防止布局错乱)
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            // 简单重载或重新计算，这里为了稳定，重新计算宽度并瞬移到最近的真实位置
            cardWidth = cards[0].getBoundingClientRect().width;
            scrollAmount = cardWidth + gap;

            // 找到当前应该显示的真实索引
            const totalRealCards = cards.length;
            // 将当前的 visual index 映射回真实 index
            let visualIndex = Math.round((-parseFloat(getComputedStyle(track).transform.split(',')[4]) || 0) / scrollAmount);
            let realIndex = ((visualIndex - cloneCount) % totalRealCards + totalRealCards) % totalRealCards;

            // 重置到真实区域的对应位置
            currentIndex = cloneCount + realIndex;
            track.style.transition = 'none';
            track.style.transform = `translateX(-${currentIndex * scrollAmount}px)`;
        }, 200);
    });

    // 启动
    startAutoScroll();
});